import { JournalContent } from "../../components/adjustment";

export default function Journal() {
  return <JournalContent />;
}
